export function assert(condition, msg) {
    if (!condition)
        throw Error(msg);
}
